import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';
import advanced from 'dayjs/plugin/advancedFormat';
dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(advanced);
export const formatTime = (time, format = 'h:mmA') => {
    return dayjs.utc(dayjs(time)).local().format(format);
};
export const formatWholesalerCutoff = (time) => {
    if (time) {
        const timeStr = time.split('T')[1];
        const today = new Date();
        const [hours, minutes] = timeStr.split(':');
        const utcDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), parseInt(hours, 10), parseInt(minutes, 10), 0));
        return formatTime(utcDate.toISOString(), 'h:mm A z');
    }
    return 'N/A';
};
